import EfSection from '@elem/ui/ef-section';
import EfSpec from '@elem/ui/ef-spec';
import SubItem from '../TraditionalUPS/SubItem';
import styles from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import getLocal from '@/app/utils/getLocal';

export default function TheComp() {
    const { locale = 'eu' } = getLocal();
    const IS_UK_SITE = locale === 'uk';

    const { useLang } = useGlobal();
    const { t } = useLang('theProduct.NonstopPower');

    const imgs = {
        pc: IS_UK_SITE
            ? 'https://websiteoss.ecoflow.com/upload/image/1741156859952/3_1.png'
            : 'https://websiteoss.ecoflow.com/upload/image/1741077872927/NonstopPower_pc.jpg',
        pad: IS_UK_SITE
            ? 'https://websiteoss.ecoflow.com/upload/image/1741156870108/3_1.png'
            : 'https://websiteoss.ecoflow.com/upload/image/1741077873297/NonstopPower_pad.jpg',
        h5: IS_UK_SITE
            ? 'https://websiteoss.ecoflow.com/upload/image/1741156879683/3_1.png'
            : 'https://websiteoss.ecoflow.com/upload/image/1741077910942/NonstopPower_h5.jpg',
    };

    const list = [
        {
            text: t('bar1_text'),
            count: t('bar1_count'),
        },
        {
            text: t('bar2_text'),
            count: t('bar2_count'),
        },
    ];

    return (
        <div className={styles.TheComp}>
            <EfSpec />
            <EfSection hasAnimation={false} label={t('label')} title={t('title')} desc={t('desc')} />
            <SubItem className="NonstopPower-item" title={t('subItem1_title')} imgs={imgs} list={list} />
            <EfSpec />
        </div>
    );
}
